export * from './history';
// eslint-disable-next-line import/no-cycle
export * from './axiosResponse';
export { timeSince, getRelativeDuration, localTimeString } from './time';
export { cutTo2Decimals } from './decimal';
export { download, downloadAsCSV } from './download';
export { humanize, humanizeRole, humanizeEventDefinition } from './humanize';
export { hasBroadbandFeature } from './broadbandFeatures';

let gIsMouseDown = 0;
document.body.onmousedown = () => {
  gIsMouseDown = 1;
};
document.body.onmouseup = () => {
  gIsMouseDown = 0;
};

export const isMouseDown = () => gIsMouseDown;
